import React from "react";
import Grid from "@material-ui/core/Grid";
import { useHistory, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
    async_Profile,
    reselect_Profile_condition,
    reselect_Profile_entity,
} from "../../../../controllers/profile-route/redux-store/profile/profile";
import { default as __locale } from "../../../../helper/location/location";
import __translate from "../../../../helper/locale/locale";
import UserActionsItem from "./UserActionsItem/UserActionsItem";
import { SIGN_LINK } from "../../../../constants/site/common";

const UserActions = () => {
    const params = useParams<{ ru: string }>();
    const dataProfile = useSelector(reselect_Profile_entity);
    const dispatch = useDispatch();
    const history = useHistory();
    const cond = useSelector(reselect_Profile_condition);
    React.useEffect(() => {
        if (!cond.inProgress) dispatch(async_Profile());
    }, []);
    const userType = dataProfile?.user_type;
    const isAdmin = userType === "admin";
    const name = `${dataProfile?.surname || ""} ${dataProfile?.name?.substr(0, 1)?.concat(".") || ""}${
        dataProfile?.lastname?.substr(0, 1).concat(".") || ""
    }`;
    if (dataProfile || isAdmin) {
        return (
            <>
                {isAdmin ? (
                    <UserActionsItem
                        key={0}
                        descLink={__translate("site.admin_panel", "Панель администратора")}
                        onClick={() => {
                            history.push(`/${__locale()}/admin`);
                        }}
                    />
                ) : (
                    <UserActionsItem
                        key={0}
                        descLink={name !== "  " ? name : "Личный кабинет"}
                        onClick={() => {
                            history.push(`/${__locale()}/user/personal-data`);
                        }}
                    />
                )}
                {/*<UserActionsItem*/}
                {/*    key={1}*/}
                {/*    descLink={__translate("system.exit", "Выйти")}*/}
                {/*    onClick={e => {*/}
                {/*        e.preventDefault();*/}
                {/*        dispatch(*/}
                {/*            asyncTokenRevoke(result => {*/}
                {/*                // @ts-ignore*/}
                {/*                window.location = window.location.origin + `/${__locale()}/login`;*/}
                {/*            }),*/}
                {/*        );*/}
                {/*    }}*/}
                {/*/>*/}
            </>
        );
    } else {
        return (
            <div style={{ display: "flex", alignItems: "center" }}>
                {SIGN_LINK.map(elem => (
                    <UserActionsItem
                        key={elem.key}
                        descLink={__translate(elem.key, elem.desc)}
                        link={elem.link}
                    />
                ))}
            </div>
        );
    }
};

export default UserActions;
